import { render, staticRenderFns } from "./TemoignagesCard.vue?vue&type=template&id=18a2e2ac&"
import script from "./TemoignagesCard.vue?vue&type=script&lang=js&"
export * from "./TemoignagesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports